export default __webpack_public_path__ + "static/media/article_with_image.ea0f31d2.svg";